import { render, staticRenderFns } from "./ReportCompetency2.vue?vue&type=template&id=06dcf05a&scoped=true"
import script from "./ReportCompetency2.vue?vue&type=script&lang=js"
export * from "./ReportCompetency2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dcf05a",
  null
  
)

export default component.exports